module.exports = __webpack_public_path__ + "img/quayRamp.0584a683.svg";